<template>
  <div v-if="filter && loadingFilters"></div>
  <div v-else>
    <v-toolbar class="toolbar-element" light :style="{'position':toolBarNotAbsolute ? 'static' : 'absolute','borderRadius': borderRadius ? '15px' : null}" absolute flat height="90em" v-if="toolbar">
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-toolbar-title class="toolbar-title">{{ toolbarTitle }}</v-toolbar-title>
        <slot name="toolbar-table"></slot>
        <v-spacer></v-spacer>
      </template>
      <v-flex :xs4="$vuetify.breakpoint.smAndUp" v-if="searchText">
        <v-text-field v-model="search" solo light append-icon="search" :label="searchText"
                      single-line hide-details flat></v-text-field>
      </v-flex>
    </v-toolbar>

    <div :class="{'spacing-top' : toolbar && toolBarNotAbsolute ? null : toolbar }">
      <slot name="before-filters"></slot>
      <v-card-actions class="filter-bar mb-0 pb-0 dates date-filter-bar">
        <v-spacer></v-spacer>
        <template v-if="filter">
          <template v-for="header in getDateHeaders(headers)">
            <DatePickerForm class="date-filter"
                    v-model="filters[header.value]"
                    :label="header.text"
                    clearable
                    :key="header.text">
            </DatePickerForm>
          </template>
        </template>
      </v-card-actions>
      <v-card-actions class="filter-bar mb-0 pb-0">
        <div class="text-grey mr-2 pt-2 mt-2">{{ totalItems }} resultados</div>
        <v-spacer></v-spacer>
        <template v-if="filter">
          <template v-for="header in getArrayWithoutLastItem(headers)">
            <v-autocomplete flat hide-details small :multiple="!header.filterFieldUniqueValue" clearable :label="header.text" outline light height="30"
                            :items="columnValueList(header.value)" v-model="filters[header.value]" :key="header.text"
                            no-data-text="No hay datos disponibles"
                            v-if="filters.hasOwnProperty(header.value) && !header.dateFilterField"
                            class="filter-element select-element dense-select" solo dense>
              <v-list-tile slot="prepend-item" v-if="!header.filterFieldUniqueValue" ripple @click="selectAll(header)">
                <v-list-tile-action>
                  <v-icon
                    v-if="defaultToPrimera"
                    :color="isAllSelected(header) ? 'primary' : ''"
                  >
                    {{ isAllSelected(header) ? 'check_box' : 'check_box_outline_blank' }}
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Seleccionar todos</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                slot="prepend-item"
                v-if="header.value === 'club' && defaultToPrimera"
                ripple
                @click="selectOnlyPrimera(header)"
              >
                <v-list-tile-action>
                  <v-icon :color="isOnlyPrimeraSelected(header) ? 'primary' : ''">
                    {{ isOnlyPrimeraSelected(header) ? 'check_box' : 'check_box_outline_blank' }}
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Sólo primera</v-list-tile-title>
              </v-list-tile>
              <v-divider slot="prepend-item"></v-divider>
              <v-divider slot="prepend-item"></v-divider>
              <template slot="selection" slot-scope="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <span v-if="index === 1" class="text-grey">&nbsp;(+{{ filters[header.value].length - 1 }} más)</span>
              </template>
            </v-autocomplete>
          </template>
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="submitFiltering" flat>
              <v-icon color="primary">search</v-icon>
            </v-btn>
            <span>Filtrar</span>
          </v-tooltip>
          <slot name="after-filters"></slot>
        </template>
      </v-card-actions>
      <div class="white-box">
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          :rows-per-page-items="[10, 25, 50]"
          rows-per-page-text="Ítems por página:"
          class="table-element dense-table-header mt-2"
          hide-actions
          light
          disable-initial-sort>
          <template slot="headers" slot-scope="props">
            <tr class="table-header">
              <template v-for="header in props.headers" >
                <th :key="header.text" v-if="!(header.hasOwnProperty('visible') && !header.visible)"
                  :class="['header-title', 'column sortable', pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '', `text-xs-${header.align}`]"
                  @click="changeSort(header)">
                  <span class="header-title white--text">{{ header.text }}</span>
                  <v-icon color="white" small v-if="!(header.hasOwnProperty('sortable') && !header.sortable)">arrow_upward</v-icon>
                </th>
              </template>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <slot name="first-column" :item="props.item" v-if="slotName === 'first-column'"></slot>
            <td v-for="(property, index) in properties" :key="property"
                :class="['table-row', getAlignment(index), { 'compact-row': compact }]" :style="hasCustomColorRow ? `backgroundColor: ${getColorValue(props.item)}` : null">
              <div :class="['limit-height', 'limit-width', getWidth(index)]">{{ getFieldValue(props.item, index) || getDefaultValue(property) }}</div>
            </td>
            <slot name="second-last-column" :item="props.item" v-if="slotName === 'second-last-column'"></slot>
            <td v-if="actionButtonsName" :class="[compact ? 'text-xs-center' : 'text-xs-right', 'table-row', { 'compact-row': compact }]" :style="hasCustomColorRow ? `backgroundColor: ${getColorValue(props.item)}` : null" :key="'action'"><component :is="actionButtonsName" :item="props.item"></component></td>
          </template>

          <template slot="no-data">
            <div class="text-xs-center" v-if="loading">Cargando datos...</div>
            <div class="text-xs-center" v-else>No hay datos disponibles</div>
          </template>
        </v-data-table>
        <div class="text-xs-right pagination-element">
          <v-pagination light v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoletinActionButtons from '../../features/boletines/components/BoletinActionButtons'
import LiquidacionActionButtons from '../../features/liquidaciones_tv/components/LiquidacionActionButtons'
import LiquidacionJugadorActionButtons from '../../features/liquidaciones_jugadores/components/LiquidacionJugadorActionButtons'
import EventoActionButtons from '../../features/eventos/components/EventoActionButtons'
import NotificationActionButtons from '../../features/notification/components/NotificationActionButtons'
import ExpirationActionButtons from '../../features/dashboard/components/ExpirationActionButtons'
import PresentacionListActionButtons from '../../features/presentacion/components/PresentacionListActionButtons'
import PresentacionUpdateListActionButtons from '../../features/presentacion_update/components/PresentacionUpdateListActionButtons'
import ConsultasListActionButtons from '../../features/consulta/components/ConsultasListActionButtons'
import PlayersListActionButtons from '../../features/players/components/PlayersListActionButtons'
import CuerpoTecnicoListActionButtons from '../../features/players/components/CuerpoTecnicoListActionButtons'
import ContractsListActionButtons from '../../features/players/components/ContractsListActionButtons'
import ConditionsListActionButtons from '../../features/players/components/ConditionsListActionButtons'
import ExpedienteListActionButtons from '../../features/expedientes/components/ExpedienteListActionButtons'
import InformesListActionButtons from '../../features/pago_a_jugadores/components/InformesListActionButtons'
import PagosListActionButtons from '../../features/pago_a_jugadores/components/PagosListActionButtons'
import DeudasListActionButtons from '../../features/deudas_entre_clubes/components/DeudasListActionButtons'
import CuotasListActionButtons from '../../features/deudas_entre_clubes/components/CuotasListActionButtons'
import InformeAuditoriaActionButton from '../../features/informes-auditorias/components/InformeAuditoriaActionButton'
import { paginationMixin } from '../../mixins/paginationMixin'
import DatePickerForm from './DatePickerForm'
import MovimientosListActionButtons from '../../features/expedientes/components/MovimientosListActionButtons.vue'
import MovimientosListActionButtonsClub from '../../features/expedientes/components/MovimientosListActionButtonsClub.vue'
import TransferenciasJugadoresActionButtons from '../../features/transferencia_jugadores/components/TransferenciasJugadoresActionButtons'
import ReportContractsDetailActionButtons from '../../features/reports/components/ReportContractsDetailActionButtons'
import PresentacionCargaLpfActionButtons from '../../features/presentaciones_carga_lpf/components/PresentacionCargaLpfActionButtons'

export default {
  mixins: [paginationMixin],

  props: {
    headers: Array,
    path: String,
    filterPath: String,
    actionButtonsName: String,
    properties: Array,
    filter: Boolean,
    slotName: String,
    toolbar: Boolean,
    toolbarTitle: String,
    searchText: String,
    defaults: {
      type: Object,
      default: () => { return {} }
    },
    toolBarNotAbsolute: Boolean,
    borderRadius: Boolean,
    hasCustomColorRow: Boolean,
    compact: {
      type: Boolean,
      default: false
    },
    defaultToPrimera: {
      type: Boolean,
      default: false
    },
    estVerifPend: {
      type: Boolean,
      default: false
    }
  },

  components: {
    BoletinActionButtons,
    EventoActionButtons,
    NotificationActionButtons,
    ExpirationActionButtons,
    PresentacionListActionButtons,
    PresentacionUpdateListActionButtons,
    ConsultasListActionButtons,
    PlayersListActionButtons,
    ContractsListActionButtons,
    ExpedienteListActionButtons,
    LiquidacionActionButtons,
    LiquidacionJugadorActionButtons,
    DatePickerForm,
    ConditionsListActionButtons,
    InformesListActionButtons,
    PagosListActionButtons,
    CuerpoTecnicoListActionButtons,
    DeudasListActionButtons,
    CuotasListActionButtons,
    InformeAuditoriaActionButton,
    MovimientosListActionButtons,
    MovimientosListActionButtonsClub,
    TransferenciasJugadoresActionButtons,
    ReportContractsDetailActionButtons,
    PresentacionCargaLpfActionButtons
  },

  watch: {
    loadingFilters (newVal) {
      if (!newVal && this.defaultToPrimera) {
        this.setInitialPrimeraFilter()
      }
      if (!newVal && this.estVerifPend) {
        this.setInitialStatusFilter()
      }
    }
  },

  mounted () {
    if (this.filter && !this.loadingFilters) {
      if (this.defaultToPrimera) {
        this.setInitialPrimeraFilter()
      }
      if (this.estVerifPend) {
        this.setInitialStatusFilter()
      }
    }
  },

  methods: {
    isAllSelected (header) {
      const selectedValues = this.filters[header.value] || []
      const allValues = this.columnValueList(header.value) || []

      return selectedValues.length > 0 && selectedValues.length === allValues.length
    },

    isOnlyPrimeraSelected (header) {
      const selectedValues = this.filters[header.value] || []
      const allItems = this.columnValueList(header.value) || []
      const primeraValues = allItems.filter(item => item.primera === true).map(item => item.value)

      if (selectedValues.length === 0 || selectedValues.length !== primeraValues.length) {
        return false
      }

      return selectedValues.every(val => primeraValues.includes(val))
    },
    selectOnlyPrimera (header) {
      if (this.isOnlyPrimeraSelected(header)) {
        this.filters[header.value] = []
      } else {
        let allItems = this.columnValueList(header.value)
        let primeraValues = allItems.filter(item => item.primera === true).map(item => item.value)

        this.filters[header.value] = primeraValues
      }

      this.$forceUpdate()
    },

    setInitialPrimeraFilter () {
      if (!this.headers) return

      let clubHeader = this.headers.find(h => h.value === 'club')
      if (clubHeader && this.filters.hasOwnProperty('club')) {
        if (!this.filters['club'] || this.filters['club'].length === 0) {
          this.selectOnlyPrimera(clubHeader)

          if (typeof this.submitFiltering === 'function') {
            this.submitFiltering()
          }
        }
      }
    },
    setInitialStatusFilter () {
      if (!this.headers) return

      let statusHeader = this.headers.find(h => h.value === 'status')
      if (statusHeader && this.filters.hasOwnProperty('status')) {
        if (!this.filters['status'] || this.filters['status'].length === 0) {
          this.filters['status'] = [2, 3]
          if (typeof this.submitFiltering === 'function') {
            this.submitFiltering()
          }
        }
      }
    },
    selectAll (header) {
      let selectedValues = this.filters[header.value]
      let allValues = this.columnValueList(header.value).slice().map(item => item.value)

      if (selectedValues.length === allValues.length) {
        this.filters[header.value] = []
      } else {
        this.filters[header.value] = allValues
      }
      this.$forceUpdate()
    },
    getFieldValue (item, index) {
      let propertyList = this.properties[index].split('.')
      let fieldValue = item
      for (let property of propertyList) {
        if (property) {
          fieldValue = fieldValue[property]
        }
      }
      return fieldValue
    },
    getDefaultValue (property) {
      return (this.defaults.hasOwnProperty(property)) ? this.defaults[property] : ''
    },
    getArrayWithoutLastItem (array) {
      return array.slice(0, array.length - 1)
    },
    getDateHeaders (array) {
      let dateHeaders = []
      let headers = this.getArrayWithoutLastItem(array)
      for (var i = 0; i < headers.length; i++) {
        if (headers[i].dateFilterField) {
          dateHeaders.push(headers[i])
        }
      }
      return dateHeaders
    },
    getAlignment (index) {
      let alignment = this.headers[index].align
      return (alignment) ? `text-xs-${alignment}` : 'text-xs-center'
    },
    getWidth (index) {
      let header = this.headers[index]
      return (header.value === 'description') ? 'observation-text' : ''
    },
    getColorValue (item) {
      if ('rowColor' in item) {
        return item.rowColor
      }
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em;
}
.white-box {
  background-color: white;
}
.table-header {
  background-color: #293968;
}
.table-row {
  background-color: white;
  border-bottom: 1px solid #959ba6;
  color: #5f5b5b;
  font-size: 1.05em;
}
.limit-height {
  overflow: hidden;
  max-height: 4.5em;
}
.limit-width {
  overflow: hidden;
  max-width: 40em;
}
.observation-text {
  max-width: 15em;
}
.table-element {
  margin-top: 1em;
  font-family: SourceSansProRegular, sans-serif;
}
.header-title {
  font-size: 1.05em;
}
th.header-title {
  border-bottom: 7.5px solid #0BBAD9;
}
.pagination-element {
  margin-top: 2em;
  padding-bottom: 1em;
}
.text-grey {
  color: #5f5b5b;
}
.filter-element {
  font-family: SourceSansProRegular, sans-serif;
  font-size: 1.1em;
  padding-right: 0.5em;
}
.select-element {
  max-width: 20em;
}
.filter-bar {
  margin-bottom: 0.5em;
}
.date-filter-bar {
  margin-right: 7em;
}
.date-filter {
  margin-right: 1em;
  margin-left: 1em;
}
.table-row.compact-row {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  height: auto !important;
}

.table-row.compact-row .v-btn {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  height: auto !important;
}
</style>
